

export const projectsArray = [


    {
        id: 1,
        title: 'World Map',
        shortDescription: 'Angular World Map App',
        description: 'This Angular map assignment involves building an interactive world map application using Angular framework. The map allows users to click on different countries to display relevant data, such as population, capital city, or additional metadata retrieved from an external API. The application demonstrates key Angular concepts including component-based architecture, data binding, service integration for HTTP requests, and responsive design. It offers a dynamic user experience with real-time data updates and showcases the use of Angular’s routing and lifecycle hooks to manage state and interactivity within the application.',
        link: 'https://dawsonbolen.github.io/Interactive-Map/map',
        image: '/project-images/map.jpg',
        repo: 'https://github.com/DawsonBolen/Interactive-Map',
        technologies: [
            {
                techName: "Angular",
                techIcon: "/images/angular-icon.png"
            },
            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },



        ]
    },

    {
        id: 3,
        title: 'EZ Trade',
        shortDescription: 'Ecommerce Website',
        description: "EZ trade was a full stack ecommerce site that I made along with a group for a project. We used Handlebars, JavaScript, Express, Node, and CSS. I helped slightly with routing and express, but my role was primarily front end. I did the majority of the front end work. I did all of the design and css, created all of our graphics using adobe Illustrator, designed the logo, and did the majority of the front-end JavaScript and handlebars. We used live share, so it probably looks like one member did all of the pushes, but everyone contributed. The project manager took it down so he wouldn't be charged so you can clone the repo and run npm i and npm run dev to view our site in action. I will work to get a walkthrough video up in the next week or so.  ",
        image: '/project-images/ez-trade.jpg',
        repo: 'https://github.com/robagraham808/Ez-trade',

        technologies: [
            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },
            {
                techName: "Handlebars",
                techIcon: "/images/handlebarsicon.png"
            },
            {
                techName: "Express",
                techIcon: "/images/expressicon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },

            {
                techName: "SQL",
                techIcon: "/images/sqlicon.png"
            },


            {
                techName: "Illustrator",
                techIcon: "/images/aiicon.png"
            },


        ]

    },
    {
        id: 4,
        title: 'Square Share',
        shortDescription: 'Social Network App',
        description: "This was our final project for my coding bootcamp. We created a social networking app called square share. It is a full stack MERN application. You can create discussion threads and add post to those threads. Additionally, you can add comments. My role was primarily front end. I helped a little bit with graph and would have to work with it to get the front end to work properly. I did the majority of the react and all of the css. Additionally, I designed it and created our graphics in illustrator. In addition to the MERN stack, we also used graphql, apollo client, and jwt web tokens for authentication. ",
        link: 'https://sharesquare-c95734f95f40.herokuapp.com/Home',
        image: '/project-images/square-share.jpg',
        repo: 'https://github.com/DawsonBolen/project-3',
        technologies: [
            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },
            {
                techName: "React",
                techIcon: "/images/reacticon.png"
            },
            {
                techName: "Express",
                techIcon: "/images/expressicon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },

            {
                techName: "MongoDB",
                techIcon: "/images/mongodbicon.png"
            },
            {
                techName: "GraphQL",
                techIcon: "/images/gqlicon.png"
            },

            {
                techName: "Illustrator",
                techIcon: "/images/aiicon.png"
            },


        ]

    },

    {
        id: 6,
        title: 'Connect 4',
        description: "I created a connect 4 game for a class using HTML, CSS, and JavaScript. This was one of my first major projects for school several years ago, so i may decide to improve it since I've learned a lot since then. Press the button to view the site and play the game. ",
        shortDescription: 'connect 4 game',
        link: 'https://dawsonbolen.github.io/Connect-4/',
        image: '/project-images/connect-four.jpg',
        repo: 'https://github.com/DawsonBolen/Connect-4',



        technologies: [
            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            },

            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },
            {
                techName: "Illustrator",
                techIcon: "/images/aiicon.png"
            },


        ]
    },
    {
        id: 7,
        title: 'St Vincent De Paul',
        description: 'I worked in a group to create a mockup website for St. Vincent de Paul. Their current website was super outdated and they wanted new ideas. We also conducted UX research before finalizing our designs. I was responsible for our creating personas and creating the partners page. Click the button to view the full adobe XD document. ',
        shortDescription: 'UX Design Project',
        link: 'https://xd.adobe.com/view/c792ce5e-a6d5-4bb0-86dd-2231d00e27f3-92c1/?fullscreen',
        image: '/project-images/st-vincent.jpg',


        technologies: [
            {
                techName: "Adobe XD",
                techIcon: "/images/xdicon.png"
            },

            {
                techName: "Photoshop",
                techIcon: "/images/apicon.png"
            },
            {
                techName: "Illustrator",
                techIcon: "/images/aiicon.png"
            },

        ]

    },

    {
        id: 9,
        title: 'Coding Quiz',
        description: "I created a coding quiz for a class. It's 5 questions long and is timed. It also uses local storage to display the past scores on the last page. I made this using html, css, and JavaScript. ",
        shortDescription: 'Timed Coding Quiz',
        link: 'https://dawsonbolen.github.io/coding-quiz/',
        image: '/project-images/coding-quiz.jpg',
        repo: 'https://github.com/DawsonBolen/coding-quiz',

        technologies: [
            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            },

            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },


            {
                techName: "Illustrator",
                techIcon: "/images/aiicon.png"
            },

        ]

    },
    {
        id: 10,
        title: 'NBA Highlights',
        description: "This was a group project in my coding bootcamp. We created an NBA Highlights app that allows the user to search up a team, get that teams record, and get game stats for every game of their season. Additionally, it used the youtube api to retrieve relevant videos. My personal job was being the main person in charge of the NBA Api. It was a very simple api which limitied what we could do. It just returned raw text data, however, because of this I really got to practice and refine my skills with JavaScript logic. Unfortunately, the Ball Don't Lie API no longer exists, so the main portion of this project no longer works. ",
        shortDescription: 'NBA API app',
        link: 'https://rau1avi1a.github.io/NBA-Highlights/',
        image: '/project-images/NBA-Highlights.jpg',
        repo: 'https://github.com/rau1avi1a/NBA-Highlights',

        technologies: [
            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            },

            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },

        ]

    },
    {
        id: 11,
        title: 'Workday Scheduler',
        description: "This was an assignment in my coding bootcamp class. We took existing html and css, but added our own J Querry code to create a workday scheduler. This used many concepts such as J Querry and local storage. ",
        shortDescription: 'Workday scheduling app',
        link: 'https://dawsonbolen.github.io/workday-scheduler/',
        image: '/project-images/workday-scheduler.jpg',
        repo: 'https://github.com/DawsonBolen/workday-scheduler',

        technologies: [
            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            },

            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },

            {
                techName: "jQuery",
                techIcon: "/images/jqueryicon.png"
            },



        ]

    },

    {
        id: 13,
        title: 'Random Password',
        description: "This assignment was also for my coding bootcamp. We created this Random Password Generator from starting source code and added JavaScript to make it work correctly. ",
        shortDescription: 'Random Password Generator',
        link: 'https://dawsonbolen.github.io/Random-Password/',
        image: '/project-images/password-generator.jpg',
        repo: 'https://github.com/DawsonBolen/Random-Password',


        technologies: [
            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            },

            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },

        ]

    },
    {
        id: 14,
        title: 'README Generator',
        description: "This assignment was also for my coding bootcamp. We created this README.md Generator from starting source code and added JavaScript to make it work correctly. It uses node.js and inquirerer to build a readme file based on user input. It is a command line app and is not deployed so instead of a link, I added a walkthrough video below. ",
        shortDescription: 'Command Line README Generator',
        link: 'https://drive.google.com/file/d/1qITiMJ0AB_C-JX3H-7F0AYuoU7hmkI64/view',
        image: '/project-images/readme-generator.jpg',
        repo: 'https://github.com/DawsonBolen/readme-generator',


        technologies: [
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },


        ]

    },
    {
        id: 15,
        title: 'SVG Logo Generator',
        description: "This is an app that generates an svg logo from the command line. This was built with node.js and inquirer to take user input in order to generate an svg logo. The user can choose the shape, shape color, text, and text color to create a custom logo. I used an object oriented approach to this assignment. Once again, I included a walkthrough video below. ",
        shortDescription: 'Command line logo generator',
        link: 'https://drive.google.com/file/d/1FPmaqyTL9zud4SLVjRlqRFWyjJyVFi0g/view',
        image: '/project-images/svg-logo-generator.jpg',
        repo: 'https://github.com/DawsonBolen/SVG-Logo-Generator',

        technologies: [
            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },

            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },

            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            },




        ]

    },
    {
        id: 16,
        title: 'Note Taker',
        description: "This is a note taking app that uses a JSON data base to create and store notes. It was created using a custom restful API using Node and Express.js",
        shortDescription: 'Note taking app',
        link: 'https://note----taking--app.herokuapp.com/',
        image: '/project-images/Note-taker.jpg',
        repo: 'https://github.com/DawsonBolen/Note-Taker',

        technologies: [
            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },
            {
                techName: "Express",
                techIcon: "/images/expressicon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },
            {
                techName: "html",
                techIcon: "/images/htmlicon.png"
            }



        ]

    },
    {
        id: 17,
        title: 'Employee Tracker',
        description: "This is an employee tracker app that uses node.js, express.js, and sql. You can add employees, add roles, add departments, and add managers as well as delete and edit each of these as well. It is a command line app so it is not deployed. You may view the repo and the walkthrough video however. ",
        shortDescription: 'Command Line Employee Tracker',
        link: 'https://drive.google.com/file/d/1zTUW1KpqgFj_wzRFARDnKDPvXZlXFnKh/view',
        image: '/project-images/employee-tracker.jpg',
        repo: 'https://github.com/DawsonBolen/Employee-Tracker',

        technologies: [

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },

            {
                techName: "Express",
                techIcon: "/images/expressicon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },

            {
                techName: "SQL",
                techIcon: "/images/sqlicon.png"
            },




        ]

    },
    {
        id: 18,
        title: 'Social Network API',
        description: "This is a social network API. It is just a backend server application so it is not deployed to anything. It can be tested in Insomnia and you can view the repo and watch my walkthrough video. I used Node, MongoDB, Mongoose, and Express to create this api. You can add users, create thoughts which are supposed to be like posts for any social media site, you can add reactions to those thoughts, and you can add friends to users. Additionally, you can delete all of these or edit them as well. ",
        shortDescription: 'MongoDB Social Network API',
        link: 'https://drive.google.com/file/d/12nNGqZhfPxt7GBSZ-KUogpHxnOpUuCTW/view',
        image: '/project-images/social-network-api.jpg',
        repo: 'https://github.com/DawsonBolen/Social-Network-API',


        technologies: [

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },
            {
                techName: "Express",
                techIcon: "/images/expressicon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },

            {
                techName: "MongoDB",
                techIcon: "/images/mongodbicon.png"
            },



        ]

    },
    {
        id: 19,
        title: 'NAMI',
        description: 'I worked with a group to create a website for Nami North Central Idaho. I helped design it and was in charge of the technical side of the project as well. Unfortunately, they are no longer around so the site is no longer there. Their organization just merged with NAMI Idaho. It is unfortunate, however, this was a great learning experience to actually work for a real client.',
        shortDescription: 'Website Build',
        image: '/images/namireal.jpg',


        technologies: [


            {
                techName: "CSS",
                techIcon: "/images/cssicon.png"
            },
            {
                techName: "WordPress",
                techIcon: "/images/wpicon.png"
            },
            {
                techName: "Illustrator",
                techIcon: "/images/aiicon.png"
            },

            {
                techName: "Photoshop",
                techIcon: "/images/apicon.png"
            },


        ]

    },
    {
        id: 20,
        title: 'Ecommerce Backend',
        description: 'This is the backend for an ecommerce site. It handles get requests, delete requests, put requests, and post requests which would all be necassary for running and maintaining an ecommerce site. It is just a backend so it is linked to a walkthrough video. ',
        shortDescription: 'Ecommerce Backend using MongoDB',
        link: 'https://drive.google.com/file/d/1My8wGW2euyjX2QfpSUE2stbEFQpNqbtg/view',
        image: '/project-images/e-commerce.jpg',
        repo: 'https://github.com/DawsonBolen/E-Commerce',

        technologies: [

            {
                techName: "JavaScript",
                techIcon: "/images/javascripticon.png"
            },

            {
                techName: "Express",
                techIcon: "/images/expressicon.png"
            },
            {
                techName: "Node",
                techIcon: "/images/nodeicon.png"
            },

            {
                techName: "SQL",
                techIcon: "/images/sqlicon.png"
            },




        ]


    },
]



export const designProjects = [
    {
        id: 1,
        title: 'Mind Space',
        description: 'This project was for a fine arts class. It was a digital media class that I really enjoyed. This was the mind space project. We were able to make any space that came to mind. I chose to make this futuristic city setting because I really like Sci Fi.',
        image: '/project-images/mindspaceweb.jpg'
    },
    {
        id: 2,
        title: 'Color Theory',
        description: "For one of my graphic design classes, we had to create a color theory diagram that explained the relationships between the different hues on the color wheel as well as explain tint, shade, saturation, temperature, and complementary colors. We also had to incorporate real images that we photographed. I chose to use famous skyscrapers because it made the diagram more interesting and cool to look at.",
        image: '/project-images/Colordiagramweb.jpg'
    },
    {
        id: 3,
        title: 'Peace Of Heart',
        description: "I created this logo and this business card for Peace of Heart Therapy. I also completed a re-design of their website and overall improved the design and accessability. I have also created several other assets such as their letterhead design.",
        image: '/project-images/peaceofheartcard.jpg'
    },

    {
        id: 4,
        title: 'Fall City Days',
        description: 'My High School had a logo design competition for the Fall City Days Run. I won and my design was selected to be put on the T Shirts. With my current skills, I could definately make something better than this. However, my design did get chosen to put on the t shirts, which was a cool experience.',
        image: '/project-images/fall-city-fun-run.jpg'
    },
    {
        id: 5,
        title: 'Book Cover 1',
        description: "In my fine art graphic design class, this assignment had us create two mock up book cover designs for books or movies we've read or watched recently. I chose American Psycho because I had watched it for the first time recently. I used adobe Illustrator for the main illustration, photoshop to make the background and In Design to put everything together.",
        image: '/project-images/Americanpsychoforweb.jpg'
    },
    {
        id: 6,
        title: 'Book Cover 2',
        description: "This was my second book cover design. I chose to do lord of the flies because I think it's a great book, and there is lots of symbolism in the book too work with. I finished this one a lot faster than my other one yet I ended up liking the way this one turned out a bit more than the first one. This was done entirely in Illustrator and In design. ",
        image: '/project-images/Lordofthefliesweb-2.jpg'
    }
]

export const posters = [
    {
        id: 1,
        title: 'Distracted Driving',
        description: 'This was an inforgraphic I made for communications 210. It was a multimedia class where we practiced things like Photoshop and Illustrator. This project had us create an infographic about distracted driving using icons, graphs, and written paragraphs. I created this in adobe Illustrator.',
        image: '/project-images/infographicweb.jpg'
    },
    {
        id: 2,
        title: 'WSU Poster',
        description: 'In my communications 210 class, I created this WSU poster that was a mockup for a letter sent by the school to advertise to potential students. I created this using Illustrator, Photoshop, and InDesign.',
        image: '/project-images/wsuletterweb.jpg'
    },
    {
        id: 3,
        title: 'Ski Resort',
        description: 'Once again, this is from my com 210 class. It was an elective but it was really in line with the type of work I was studying in college anyways which was cool. This assignment had me create many mockup assets for a made up resteraunt that was supposed to be located on a ski resort. We created mockup logos, icons, and a website interface.',
        image: '/project-images/skiresort.jpg'
    },
    {
        id: 4,
        title: 'Poster Comic',
        description: 'This assignment had me create a comic that had to fit on a printed 11x17 poster. I created this simple space themed comic. I like Sci Fi so I chose to create this simple narrative of an Astronaut going through space to Mars. I really overestimated how much of a narrative I could make in such a small space, but I thought it looked cool at least.',
        image: '/project-images/postercomicweb.jpg'
    },
    {
        id: 5,
        title: 'Cultural Comparison',
        description: "This assignment had me create an infographic comparing our culture to another country. I chose Japan because I think its a cool place even though I've never been there.",
        image: '/project-images/culturalcomparrison.jpg'
    }
]

export const resumeProjects = [
    {
        id: 1,
        title: 'Square Share',
        link: 'https://sharesquare-c95734f95f40.herokuapp.com/Home',
        image: '/project-images/square-share.jpg',
        repo: 'https://github.com/DawsonBolen/project-3',
        description: "Most resumes have a projects section so I thought I would include this here to highlight my best works. However, all my projects are on the graphic design or the web development page. This is Square Share, a group project social networking site. you create community discussions, or squares as we call them. I designed all the graphics and the layout, did the majority of the react, all of the css, and helped a little bit with graphQL.",
        technologies: {
            css: "/images/cssicon.png",
            JavaScript: "/images/javascripticon.png",
            React: "/images/reacticon.png",
            Express: "/images/expressicon.png",
            Node: "/images/nodeicon.png",
            MongoDB: "/images/mongodbicon.png",
            GraphQL: "/images/gqlicon.png",
            Illustrator: "/images/aiicon.png"
        }
    },
    {
        id: 2,
        title: 'EZ Trade',
        link: 'https://sharesquare-c95734f95f40.herokuapp.com/Home',
        image: '/project-images/ez-trade.jpg',
        repo: 'https://github.com/robagraham808/Ez-trade',
        description: "Most resumes have a projects section so I thought I would include this here to highlight my best works. However, all my projects are on the graphic design or the web development page. This is another group project. It is a full stack ecommerce site called EZ trade that we made. I designed the graphics and the layout, did the majority of the handlebars, all of the css, and the majority of the front end JavaScript. The project Manager took it down so you will have to clone the repo and run it. I am going to try to get a walkthrough video made in the next week or so.",
        technologies: {
            css: "/images/cssicon.png",
            JavaScript: "/images/javascripticon.png",
            Handlebars: "/images/handlebarsicon.png",
            Express: "/images/expressicon.png",
            Node: "/images/nodeicon.png",
            SQL: "/images/sqlicon.png",
            Illustrator: "/images/aiicon.png"
        }
    },
    {
        id: 3,
        title: 'Tic Tac Toe',
        description: 'I created this tic tac toe game using react. I just made it to practice my skills in react and to keep growing them. It is just a regular tic tac toe game. It notifies who wins the game and the streak changes color, and it notifies if its a tie. You also have the option to restart or to play again. It has a 2 player and a 1 player vs the computer mode. ',
        link: 'https://dawsonbolen.github.io/tic-tac-toe/',
        image: '/project-images/tic-tac-toe.jpg',
        repo: 'https://github.com/DawsonBolen/tic-tac-toe',
        technologies: {
            React: "/images/reacticon.png",
            css: "/images/cssicon.png",
            JavaScript: "/images/javascripticon.png",
            Illustrator: "/images/aiicon.png"
        }
    },
    {
        id: 4,
        title: 'Drink Campaign',
        description: 'This is my drink campaign project which can be seen in detail on the graphic design page. The project had us create a fictional drink campaign based off of a social cause. I chose Pepsi and Earth Day. I created this with Illustrator and in design. The t shirt, poster, and can templates were made in photoshop. ',
        image: '/project-images/2.jpg',
        technologies: {
            Illustrator: "/images/aiicon.png",
            photoshop: "/images/apicon.png",
            InDesign: "/images/indesignicon.png"
        }
    },
    {
        id: 5,
        title: 'Book Covers',
        description: "This is my book cover project. This project had us create 2 book covers. I chose American Psycho because I had just watched the movie recently and Lord of the flies because I liked the book. I promise I'm not that dark, but I did pick pretty dark books. I used Illustrator and In-Design to put these together. I also used photoshop for a few minor visual effects. ",
        image: '/project-images/Lordofthefliesweb.jpg',
        technologies: {
            Illustrator: "/images/aiicon.png",
            photoshop: "/images/apicon.png",
            InDesign: "/images/indesignicon.png"
        }
    },


]